import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/export-purchase-transaction.request.dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ListPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/list-purchase-transaction.request.dto';
import { PurchaseTransactionResponseDto } from '@domain/purchase-transaction/dtos/purchase-transaction.response.dto';
import { SummaryReconciliationTransactionRequestDto } from '@domain/reconciliation-transaction/dtos/summary-reconciliation-transaction.request.dto';
import { SummaryReconciliationTransactionResponseDto } from '@domain/reconciliation-transaction/dtos/summary-reconciliation-transaction.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ReconciliationTransactionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('reconciliation/transaction');
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<PurchaseTransactionResponseDto>>(
      queryUrl,
      {},
    );
  }

  list(request: ListPurchaseTransactionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<PurchaseTransactionResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  summary(request: SummaryReconciliationTransactionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/summary`;
    return this.http.get<
      ApiResponse<SummaryReconciliationTransactionResponseDto>
    >(queryUrl, { params: { ...request } });
  }

  export(request: ExportPurchaseTransactionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/export`;
    return this.http.post<ApiResponse<ExportListResponse>>(queryUrl, request);
  }
}
